import { useSelector } from 'react-redux';
import { timestampToDate } from 'Utils/Format';
import { isFreeTrial } from 'Utils/Plans';
import { isFirstResponderUpgradePlan, isMilitaryUpgradePlan, isSheerIdFreePlan } from 'Utils/SheerIdHelpers';
import { isUpgradeSubscription } from 'Api/EvergentApi';
import { FREE_WEEK_SKU } from 'Utils/Constants';

export function usePaymentReview() {
  const promoCode = useSelector((s) => s.promoCode);
  const subscription = useSelector((s) => s.subscription);
  const { selectedPlan, selectedPlanPrice, showDefaultPromo, showFreeTrialPromo } = useSelector((s) => s.plans);
  const { totalTax } = useSelector((s) => s.checkout);

  const { hasSubscription, isNewUser, isTrialistUser, isChurnedUser, validityTill, activeSubscriptionId } =
    subscription;

  const isFreeSheerId = isSheerIdFreePlan(selectedPlan?.packageID);
  const isMilitaryUpgrade = isMilitaryUpgradePlan(selectedPlan?.packageID);
  const isFirstResponderUpgrade = isFirstResponderUpgradePlan(selectedPlan?.packageID);
  const isNonTrialistUpgrade = !isTrialistUser && hasSubscription && isUpgradeSubscription(subscription, selectedPlan);

  const priceWithPromoCode = promoCode.priceToBeCharged > 0 ? promoCode.priceToBeCharged : 0;
  const totalPackagePrice = priceWithPromoCode || selectedPlanPrice;
  let totalPrice = (totalPackagePrice + totalTax).toFixed(2) || (0).toFixed(2);

  //TODO: CLEAN UP LOGIC FOR TOTAL DUE

  // always show "Total due today" unless:
  //    1. plan is a free trial where user isn't immediately billed, or
  //    2. total price is less than 1 cent (except if military discount is being applied)
  //    3. user is downgrading plans
  let defaultTotalLabel = 'Total due today';
  if (
    //TODO: remove FREE_WEEK_SKU logic after special promo plans expire (May 30 2023)
    activeSubscriptionId === FREE_WEEK_SKU ||
    isFreeTrial(selectedPlan) ||
    (!totalPrice && !isMilitaryUpgrade && !isFirstResponderUpgrade)
  ) {
    // the following two blocks is preservation of old logic
    if (validityTill && !isMilitaryUpgrade && !isFirstResponderUpgrade) {
      defaultTotalLabel = `Total due on ${timestampToDate(validityTill, 2)}`;
    }
    if (
      selectedPlan?.hasFreePromo &&
      (isNewUser || isChurnedUser) &&
      showDefaultPromo &&
      (showFreeTrialPromo || !!selectedPlan.freePromo.amount)
    ) {
      const { freePromo } = selectedPlan;
      let billDate = freePromo.nextBillingDateTime;
      billDate = timestampToDate(billDate, 2);
      defaultTotalLabel = `Total due on ${billDate}`;
    }
  }
  if (isNonTrialistUpgrade) {
    defaultTotalLabel = 'Total due today';
  }

  let totalLabel = promoCode.totalLabel || defaultTotalLabel;

  if (isFreeSheerId) {
    totalPrice = (0).toFixed(2);
    totalLabel = 'Total Due';
  }

  return {
    totalLabel,
    totalPrice,
  };
}
